import Pricing from "./Pricing Component/Pricing";

const plans = [
  { plan: "Basic", priceMonthly: 19.99, priceAnnually: 199.99, storage: "500GB Storage", users: "2 Users Allowed", send: "Send up to 3GB" },
  { plan: "Professional", priceMonthly: 24.99, priceAnnually: 249.99, storage: "1TB Storage", users: "5 Users Allowed", send: "Send up to 10GB" },
  { plan: "Master", priceMonthly: 39.99, priceAnnually: 399.99, storage: "2TB Storage", users: "10 Users Allowed", send: "Send up to 20GB" },
];

function App() {
  return <Pricing plans={plans} />;
}

export default App;
